var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRemoveMemberIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-del",
    transform: "translate(-1295 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 18,
    height: 18,
    transform: "translate(1295 98)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-remove-circle-outline",
    "data-name": "Icon material-remove-circle-outline",
    d: "M6.5,9.3v1.4h7V9.3ZM10,3a7,7,0,1,0,7,7A7,7,0,0,0,10,3Zm0,12.6A5.6,5.6,0,1,1,15.6,10,5.607,5.607,0,0,1,10,15.6Z",
    transform: "translate(1294 97)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemoveMemberIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/removeMemberIcon.cfe228da.svg";
export { ForwardRef as ReactComponent };